var _WysiwygContentHandler_view, _WysiwygContentHandler_parser;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { Slice } from 'prosemirror-model';
import { AllSelection, TextSelection } from 'prosemirror-state';
export class WysiwygContentHandler {
    constructor(view, parser) {
        _WysiwygContentHandler_view.set(this, void 0);
        _WysiwygContentHandler_parser.set(this, void 0);
        __classPrivateFieldSet(this, _WysiwygContentHandler_view, view, "f");
        __classPrivateFieldSet(this, _WysiwygContentHandler_parser, parser, "f");
    }
    clear() {
        __classPrivateFieldGet(this, _WysiwygContentHandler_view, "f").dispatch(__classPrivateFieldGet(this, _WysiwygContentHandler_view, "f").state.tr
            .setSelection(new AllSelection(__classPrivateFieldGet(this, _WysiwygContentHandler_view, "f").state.doc))
            .replaceSelection(Slice.empty));
    }
    replace(newMarkup) {
        __classPrivateFieldGet(this, _WysiwygContentHandler_view, "f").dispatch(__classPrivateFieldGet(this, _WysiwygContentHandler_view, "f").state.tr
            .setSelection(new AllSelection(__classPrivateFieldGet(this, _WysiwygContentHandler_view, "f").state.doc))
            .replaceSelection(new Slice(__classPrivateFieldGet(this, _WysiwygContentHandler_parser, "f").parse(newMarkup).content, 0, 0)));
    }
    prepend(markup) {
        __classPrivateFieldGet(this, _WysiwygContentHandler_view, "f").dispatch(__classPrivateFieldGet(this, _WysiwygContentHandler_view, "f").state.tr.insert(0, __classPrivateFieldGet(this, _WysiwygContentHandler_parser, "f").parse(markup).content));
    }
    append(markup) {
        var _a, _b;
        let tr = __classPrivateFieldGet(this, _WysiwygContentHandler_view, "f").state.tr;
        if (((_a = tr.doc.lastChild) === null || _a === void 0 ? void 0 : _a.type.name) === 'paragraph' && tr.doc.lastChild.childCount === 0) {
            const pos = tr.doc.nodeSize - 3;
            tr = tr.replaceWith(pos - 1, pos + 1, __classPrivateFieldGet(this, _WysiwygContentHandler_parser, "f").parse(markup));
        }
        else {
            tr = this.appendContentTr(tr, markup);
        }
        if (((_b = tr.doc.lastChild) === null || _b === void 0 ? void 0 : _b.type.name) !== 'paragraph' || tr.doc.lastChild.childCount !== 0) {
            tr = this.appendContentTr(tr, '');
        }
        __classPrivateFieldGet(this, _WysiwygContentHandler_view, "f").dispatch(tr);
    }
    moveCursor(position) {
        switch (position) {
            case 'start': {
                const { tr } = __classPrivateFieldGet(this, _WysiwygContentHandler_view, "f").state;
                __classPrivateFieldGet(this, _WysiwygContentHandler_view, "f").dispatch(tr.setSelection(TextSelection.create(tr.doc, 1)));
                break;
            }
            case 'end': {
                const { lastChild } = __classPrivateFieldGet(this, _WysiwygContentHandler_view, "f").state.doc;
                const { tr } = __classPrivateFieldGet(this, _WysiwygContentHandler_view, "f").state;
                const pos = tr.doc.nodeSize - 2;
                if (!(lastChild === null || lastChild === void 0 ? void 0 : lastChild.isTextblock) && !(lastChild === null || lastChild === void 0 ? void 0 : lastChild.isText)) {
                    this.appendContentTr(tr, '');
                }
                __classPrivateFieldGet(this, _WysiwygContentHandler_view, "f").dispatch(tr
                    .setSelection(TextSelection.create(tr.doc, tr.mapping.map(pos) - 1))
                    .scrollIntoView());
                break;
            }
            default:
                throw new Error('The "position" argument must be "start" or "end"');
        }
    }
    appendContentTr(tr, markup) {
        return tr.insert(tr.doc.nodeSize - 2, __classPrivateFieldGet(this, _WysiwygContentHandler_parser, "f").parse(markup).content);
    }
}
_WysiwygContentHandler_view = new WeakMap(), _WysiwygContentHandler_parser = new WeakMap();
